import { render } from "./Specs.vue?vue&type=template&id=616b6a60&scoped=true"
import script from "./Specs.vue?vue&type=script&lang=js"
export * from "./Specs.vue?vue&type=script&lang=js"

import "./Specs.vue?vue&type=style&index=0&id=616b6a60&scoped=true&lang=css"

import exportComponent from "/home/runner/work/metal-client/metal-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-616b6a60"]])

export default __exports__